import { useEffect, useState } from "react";
import { useUploadAttachmentMutation } from "../../../Data/services/uploadAttachmentApi";
import Toast, { SuccessToast } from "../../../Hooks/useToast";
import {
  useAddVehicleMutation,
  useUpdateVehicleMutation,
} from "../../../Data/services/vehicleApi";

const useEditVehicleModal = ({ handleEditModalClose, editData, refetch }) => {
  const [rowId, setRowId] = useState("");
  const [name, setName] = useState("");
  const [model, setModel] = useState("");
  const [carType, setCarType] = useState("");
  const [make, setMake] = useState("");
  const [color, setColor] = useState("");
  const [rentalType, setRentalType] = useState("");
  const [rentalPrice, setRentalPrice] = useState("");
  const [engineCapacity, setEngineCapacity] = useState("");
  const [description, setDescription] = useState("");
  const [attachments, setAttachments] = useState([]);
  const [imagePreviews, setImagePreviews] = useState([]);
  const [sending, setSending] = useState(false);

  useEffect(() => {
    if (editData) {
      setRowId(editData.id);
      setName(editData.name || "");
      setModel(editData.model || "");
      setMake(editData.make || "");
      setCarType(editData.car_type || "");
      setColor(editData.color || "");
      setRentalType(editData.rental_type || "");
      setRentalPrice(editData.rental_price || "");
      setEngineCapacity(editData.engine_capacity || "");
      setDescription(editData.description || "");
      setImagePreviews(editData.attachments?.map((att) => att.media_url) || []);
    }
  }, [editData]);

  const [uploadAttachment, { isLoading: isUploading }] =
    useUploadAttachmentMutation();

  const handleImagePreview = (e) => {
    const files = Array.from(e.target.files);
    if (files.length > 0) {
      setAttachments(files);
      const previews = files.map((file) => URL.createObjectURL(file));
      setImagePreviews(previews);
    }
  };

  const handleImageUpload = async () => {
    const formData = new FormData();
    attachments.forEach((file) => {
      formData.append("file", file);
      formData.append("path", "vehicle");
    });

    try {
      const response = await uploadAttachment({ formData }).unwrap();
      // return response.data.map((d) => d.url);
      return response.data;
    } catch (error) {
      Toast("Failed to upload image", "error");
      return [];
    }
  };

  const [addVehicle, { isLoading: adding }] = useAddVehicleMutation();
  const [updateVehicle, { isLoading: updating }] = useUpdateVehicleMutation();

  const handleSubmit = async () => {
    setSending(true);
    try {
      let uploadedImageUrls = [];
      if (attachments.length > 0) {
        uploadedImageUrls = await handleImageUpload();
        console.log("uploadedImageUrls", uploadedImageUrls);
      }

      const data = {
        name,
        model,
        make,
        car_type: carType,
        color,
        rental_type: rentalType,
        rental_price: rentalPrice,
        engine_capacity: engineCapacity,
        description,
        attachments: uploadedImageUrls,
      };

      let response;
      if (editData) {
        response = await updateVehicle({ data, id: rowId }).unwrap();
      } else {
        response = await addVehicle(data).unwrap();
      }

      if (response.code === 200) {
        refetch();
        setSending(false);
        SuccessToast(response?.message);
        handleEditModalClose();
      }
    } catch (error) {
      if (error?.response && error?.response?.data?.message) {
        Toast(error?.response?.data?.message, "error");
      } else {
        Toast("An error occurred", "error");
      }
      handleEditModalClose();
      setSending(false);
    }
  };

  return {
    name,
    model,
    make,
    carType,
    color,
    rentalType,
    rentalPrice,
    engineCapacity,
    description,
    imagePreviews,
    isUploading,
    sending,
    setName,
    setModel,
    setMake,
    setCarType,
    setColor,
    setRentalType,
    setRentalPrice,
    setEngineCapacity,
    setDescription,
    handleImagePreview,
    handleSubmit,
  };
};

export default useEditVehicleModal;
